import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WishlistState } from './state';
import { WishlistItem } from 'src/app/shared/models';

//
// =====================
// Feature Selector
// =====================
//

export const selectWishlistState =
  createFeatureSelector<WishlistState>('wishlist');

//
// =====================
// Basic Selectors
// =====================
//

export const selectWishlistItems = createSelector(
  selectWishlistState,
  (state): WishlistItem[] => state.items
);

export const selectWishlistLoading = createSelector(
  selectWishlistState,
  (state): boolean => state.loading
);

export const selectWishlistError = createSelector(
  selectWishlistState,
  (state): string | null | undefined => state.error
);

//
// =====================
// Derived Selectors
// =====================
//

export const selectWishlistCount = createSelector(
  selectWishlistItems,
  (items): number => items.length
);

export const selectIsInWishlist = (propertyId: number) =>
  createSelector(
    selectWishlistItems,
    (items): boolean =>
      items.some(item => item.propertyId === propertyId)
  );
